package model

import kotlinx.serialization.Serializable

@Serializable
data class Points(
    val currentPointBalance: Double,
    val requiredPoints: Double,
)